<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-fussion"
>
  <p style="font-size: 16px; color: white">Loading...</p>
</ngx-spinner>

<div class="container">
  <nav class="navbar navbar-expand-lg headerCont">
    <div class="container-fluid">
      <a routerLink="/home" class="">
        <img
          src="../../../../assets/images/Dmint_Logo.svg"
          alt="CoolBrand"
          class=""
        />
      </a>
      <button
        type="button"
        class="navbar-toggler"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">        
        <div class="navbar-nav menu_row" *ngFor="let iconHeader of iconHeaders; let i = index">
          <a [routerLink]="iconHeader.headerLinkPath"
            (click)="callOverlay();getSelectedHeader(iconHeader)"
            routerLinkActive="active"
            class="nav-item nav-link" id="tour-headerTab-{{i}}"
            *ngIf="moduleByteMap"
          >         
          <img
          [src]="'data:image/svg+xml;base64,' + moduleByteMap[iconHeader.headerName+'_'+iconHeader.menuImagePath]"
          alt="subscription_icon"
          />
            <span>{{ iconHeader.headerLabel }}</span>
          </a>
        </div>
        <div class="navbar-nav menu_row" *ngFor="let moduleHeader of modulesForHiddenHeader">
          <a *ngIf="moduleByteMap" href="javascript:void(0)" (click)="openCopilotApp()" class="copilot-link">
          <img [src]="'data:image/svg+xml;base64,' + moduleByteMap[moduleHeader.moduleName]" alt="copilot"/>
            <small style="margin-left: 5px;">{{ moduleHeader.moduleName }}</small> 
          </a>
        </div>
        <div class="navbar-nav right_row ms-auto userOptions"
          (click)="openProfileCard()"
          onKeyPress=""
        >          
          <a
            *ngIf="auth?.isAuthenticated$ | async; else loggedOut"
            class="nav-item nav-link dropdown-toggle" 
            id="dropdownMenuLink"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            ><img
              src="../../../../assets/images/default_user_icon.svg"
              alt="icon"
              class="navbar_icon"
            />
            <ul class="dropdown-menu ms-auto" *ngIf="isProfileCardOpen">
              <li class="profile_section">
                <img
                  src="../../../../assets/images/default_user_icon.svg"
                  alt="icon"
                  class="profile_picture"
                />
                <ul class="profile_details">
                  <li class="name" matTooltip="{{userName}}">{{ userName }}</li>
                </ul>
              </li>
              <hr />   
              <li
                class="logout margin-bottom"
                (click)="onClickSideHeader(sideHeader)"
                onKeyPress=""                                                            
               *ngFor="let sideHeader of sideHeaders">
                <a class="dropdown-item"
                *ngIf="
                  sideHeader?.headerLabel === 'Account Settings' ||
                  (sideHeader?.headerLabel === 'Manage Modules' && userType === 'DMINT Admin') ||
                  (sideHeader?.headerLabel !== 'Account Settings' && sideHeader?.headerLabel !== 'Manage Modules' && (userType === 'DMINT Admin' || userType === 'Subscription Admin'))
                ">
                  <img style="height: 16px; width: auto"
                    [src]="'data:image/svg+xml;base64,' + moduleByteMap[sideHeader.headerName+'_'+sideHeader.menuImagePath]"
                    alt="subscription_icon"
                  />
                  {{sideHeader.headerLabel}}
                </a>
              </li>             
              <li class="logout" (click)="logout()" onKeyPress="">
                <a class="dropdown-item logout-txt-color"
                  ><img
                    src="../../../../assets/images/logout_red_icon.svg"
                    alt="logout_icon"
                  />
                  Logout</a
                >
              </li>
            </ul>
          </a>          
          <ng-template #loggedOut
            ><button
              class="primary btn btn-primary custom-button-login"
              (click)="onLoginCall()"
              *ngIf="!isUserLoggedIn && iconHeaders.length > 0"
            >
              Login
            </button></ng-template
          >
        </div>
      </div>
    </div>
  </nav>
</div>
<app-alert
  [message]="errMsg"
  *ngIf="showErrorMessageWithPopup"
  (close)="onCloseHandler()"
></app-alert>
<app-tour-guide *ngIf="showOverlayFlag" [steps]="tourSteps" [announcementId]="announcementId"></app-tour-guide>
